import React from 'react';
import './Header.scss';
import BurgerMenu from './BurgerMenu/BurgerMenu';
import '../Header/BurgerMenu/BurgerMenu.scss';

const Header = () => {

  return (
    <header className='header'>
      <BurgerMenu />
    </header>
  );
};

export default Header;